module.exports = __webpack_public_path__ + "img/icon.71333dae.png";